import { DashboardCanvas } from '@/components/dashboard/DashboardCanvas';
import { DashboardDateControl } from '@/components/dashboard/DashboardDateControl';

import { defaultPublisherDashboardDocument } from '../defaultPublisherDashboard';
import { usePublisherDashboardQueries } from '../hooks';
import { usePublisherDashboardRouteFilters } from '../usePublisherDashboardRouteFilters';
import { publisherDashboardWidgetRegistry } from '../widgetRegistry';

export function PublisherLoginDashboardContent({ publisherId }: { publisherId: string }) {
  const { range, setRange } = usePublisherDashboardRouteFilters(false);
  const queries = usePublisherDashboardQueries(publisherId, range);
  return (
    <div className="min-w-0 space-y-6">
      <section className="flex justify-end">
        <DashboardDateControl showDayNavigation value={range} onChange={setRange} />
      </section>
      <DashboardCanvas
        document={defaultPublisherDashboardDocument}
        registry={publisherDashboardWidgetRegistry}
        runtime={{ range, ...queries }}
      />
    </div>
  );
}
